"use strict";

$(function () {
  //ハンバーガーメニュー
  //--------------------------------------------
  const $trigger = $(".hamburger");
  const $gnav = $("#gnav");
  const point_header = window.matchMedia("screen and (min-width: 1180px)");

  $trigger.on("click", function () {
    const expanded = $(this).attr("aria-expanded");
    if (expanded === "false") {
      $(this)
        .attr("aria-expanded", true)
        .attr("aria-label", "メニューを閉じる");
      $gnav.attr("aria-hidden", false).slideDown();
    } else {
      $(this).attr("aria-expanded", false).attr("aria-label", "メニューを開く");
      $gnav.attr("aria-hidden", true).slideUp();
    }
  });

  function checkBreakPoint() {
    if (point_header.matches) {
      $gnav.attr("aria-hidden", false).show();
    } else {
      $trigger
        .attr("aria-expanded", false)
        .attr("aria-label", "メニューを開く");
      $gnav.attr("aria-hidden", true).hide();
    }
  }

  point_header.addListener(checkBreakPoint);

  // よくあるご質問
  //--------------------------------------------
  $(".js-accordion").on("click", function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass("open", 300);
  });

  $(".faq__nav-link").on("click", function () {
    $(".faq__nav-link").removeClass("current");
    $(this).addClass("current");
  });

  // アマゾンボタン
  //--------------------------------------------
  $(".login__amazon").on("click", function () {
    $(".off").addClass("hide");
    $(".click").addClass("show");
  });
});
